import { useContext, useState } from 'react';
import useSWR from 'swr';
import { AppProvider } from '../../context/AppProvider';

import { fetchStudents } from '../../lib/Students';

import EnrollSkeleton from '../Shared/EnrollSkeleton';

import EnrollWrapper from '../Shared/EnrollWrapper';
import EnrollItem from '../Shared/EnrollItem';
import SharedPagination from '../Shared/SharedPagination';
import PerPageDropDown from '../Shared/SharedPagination/PerPageDropdown';

const EnrollDrillTeam = ({ submissionPage, submissionPerPage, setSubmissionPage }: { submissionPage: number; submissionPerPage: number; setSubmissionPage: React.Dispatch<React.SetStateAction<number>> }) => {
  const { token } = useContext(AppProvider);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(9);
  const [isOpen, setIsOpen] = useState(true);

  const { data: studentList, isLoading, mutate: mutateList, error } = useSWR(['/wp-json/wall-of-fame/v1/enroll/', token, page, perPage], ([path, token, page, perPage]) => fetchStudents(path, token, page, perPage), { revalidateOnFocus: false });

  const totalPages = Math.ceil((studentList?.total || 0) / perPage);

  if (error) {
    return <p>error...</p>;
  }

  if (isLoading) {
    return <EnrollSkeleton isOpen={true} perPage={perPage} setIsOpen={setIsOpen} />;
  }

  return (
    <EnrollWrapper isOpen={isOpen} paginationComponent={<SharedPagination page={page} setPage={setPage} totalPages={totalPages} />} perPage={perPage} perPageDropDownComponent={<PerPageDropDown perPage={perPage} setPage={setPage} setPerPage={setPerPage} />} setIsOpen={setIsOpen}>
      {studentList?.total ? (
        studentList?.data?.map((student, index) => (
          <EnrollItem
            key={index}
            ID={student.ID}
            avatar_url={student.avatar_url}
            index={index}
            isSelected={student.isSelected}
            token={token}
            user_login={student.user_login}
            submissionPerPage={submissionPerPage}
            submissionPage={submissionPage}
            setSubmissionPage={setSubmissionPage}
            mutateList={mutateList}
          />
        ))
      ) : (
        <p className='w-full flex justify-center items-center h-full min-h-80'>Students not avilable</p>
      )}
    </EnrollWrapper>
  );
};

export default EnrollDrillTeam;
